export default "__VITE_PUBLIC_ASSET__3eed4dc1__"